@let isMobilePlatformValue = isMobilePlatform();
@let showMobileFormFieldsValue = showMobileFormFields();
<div class="base-container">
  <form [formGroup]="panelForm">
    <!-- PANEL -->
    @let selectedStationListItemValue = selectedStationListItem();
    <div class="panel">
      @if (isMobilePlatformValue && !showMobileFormFieldsValue) {
        <div style="display: flex; justify-content: space-between; width: 100%">
          <button mat-button (click)="showMobileFormFields.set(true)">
            @if (selectedStationListItemValue | isNil: false) {
              {{ selectedStationListItemValue.overwriteStationName }}
            } @else {
              --
            }
            &nbsp; | &nbsp;
            {{ selectedModelRun() }}
          </button>
          <button mat-icon-button (click)="showMobileFormFields.set(true)">
            <fa-icon [icon]="['fal', 'chevron-down']"></fa-icon>
          </button>
        </div>
      }
      @if (!isMobilePlatformValue || showMobileFormFieldsValue) {
        @if (isMobilePlatformValue) {
          <button
            mat-icon-button
            (click)="showMobileFormFields.set(false)"
            style="position: absolute; right: 0px; top: 20px; z-index: 10">
            <fa-icon [icon]="['fal', 'chevron-up']"></fa-icon>
          </button>
        }
        <!-- Master Station Search -->
        <app-global-station-search-bar
          (selectedStation)="
            onGlobalStationSelect($event)
          "></app-global-station-search-bar>
        <!-- STATION SELECT -->

        @if (hasBetweenOneAndSixStations()) {
          <mat-form-field appearance="fill" class="station-select">
            <mat-label>{{ 'PRODUCT.EPP.SELECTSTATION' | translate }}</mat-label>
            <mat-select
              formControlName="stationListItem"
              placeholder="{{ 'PRODUCT.EPP.SELECTSTATION' | translate }}"
              (selectionChange)="onStationChange($event)">
              @for (station of stationList(); track $index) {
                <mat-option [value]="station">
                  {{ station.overwriteStationName }}
                  <!-- Elevation of Station -->
                  @if (station.hasOwnProperty('elevation')) {
                    <small> | {{ station?.elevation }} m </small>
                  }
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        } @else if (hasMoreThanFiveStations()) {
          <mat-form-field appearance="fill" class="station-select">
            <mat-label>{{ 'PRODUCT.EPP.SEARCHSTATION' | translate }}</mat-label>
            <input
              type="text"
              matInput
              formControlName="stationListItem"
              placeholder="{{ 'PRODUCT.EPP.SEARCHSTATION' | translate }}"
              appResetInputMatAutocomplete
              [previousSelectedControlValue]="selectedStationListItemValue"
              [matAutocomplete]="stationsAutocomplete" />
            <mat-icon matSuffix>search</mat-icon>
            <mat-autocomplete
              #stationsAutocomplete="matAutocomplete"
              [displayWith]="displayStationName"
              (optionSelected)="onStationChange($event)">
              @for (
                station of stationListFilteredOptions$ | async;
                track $index
              ) {
                <mat-option [value]="station">
                  {{ station.overwriteStationName }}
                  <!-- Elevation of Station -->
                  @if (station.hasOwnProperty('elevation')) {
                    <small> | {{ station?.elevation }} m </small>
                  }
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        } @else if (selectedStationListItemValue) {
          <div>
            {{ selectedStationListItemValue.overwriteStationName }}
            @if (selectedStationListItemValue.hasOwnProperty('elevation')) {
              <small> | {{ selectedStationListItemValue?.elevation }} m </small>
            }
          </div>
        }

        <!-- Model Select -->
        <mat-form-field appearance="fill" class="parameterset-select">
          <mat-label>{{ 'PRODUCT.EPS.MODELS.SELECT' | translate }}</mat-label>
          <mat-select
            (selectionChange)="onModelChange($event)"
            formControlName="model"
            placeholder="{{ 'PRODUCT.EPS.MODELS.SELECT' | translate }}">
            @for (model of validModels(); track $index) {
              <mat-option [value]="model">
                {{ 'PRODUCT.EPS.MODELS.' + model | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- Parameter Select -->
        @if (selectedStationListItemValue) {
          <mat-form-field appearance="fill" class="parameterset-select">
            <mat-label>{{
              'PRODUCT.EPS.PARAMETERS.SELECT' | translate
            }}</mat-label>
            <mat-select
              (selectionChange)="onParameterChange($event)"
              formControlName="parameter"
              placeholder="{{ 'PRODUCT.EPS.PARAMETERS.SELECT' | translate }}">
              @for (parameter of validParameters(); track $index) {
                <mat-option [value]="parameter">
                  {{ 'PRODUCT.EPS.PARAMETERS.' + parameter | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <!-- ModelRun Select -->
        @let modelRunsValue = modelRuns();
        @if (modelRunsValue.length > 1) {
          <mat-form-field appearance="fill" class="parameterset-select">
            <mat-label>{{
              'PRODUCT.EPS.MODELRUN.SELECT' | translate
            }}</mat-label>
            <mat-select
              formControlName="modelRun"
              placeholder="{{ 'PRODUCT.EPS.MODELRUN.SELECT' | translate }}"
              (selectionChange)="onModelRunChange($event)">
              @if (availableModelRuns().length > 0) {
                <mat-optgroup label="Available runs">
                  @for (modelRun of availableModelRuns(); track $index) {
                    <mat-option [value]="modelRun">
                      {{ modelRun | datex: '' : '' : language() : 'utc' }}z
                    </mat-option>
                  }
                </mat-optgroup>
              }

              @if (unavailableModelRuns().length > 0) {
                <mat-optgroup label="No data yet">
                  @for (modelRun of unavailableModelRuns(); track $index) {
                    <mat-option [value]="modelRun" disabled>
                      {{ modelRun | datex: 'short' : '' : language() : 'utc' }}z
                      — no data
                    </mat-option>
                  }
                </mat-optgroup>
              }
            </mat-select>
          </mat-form-field>

          @if (showUpcomingModelRunHint()) {
            <span
              class="modelrun-hint"
              [class.modelrun-hint--available]="nextUpcomingModelRunHasData()"
              [class.modelrun-hint--pending]="!nextUpcomingModelRunHasData()">
              @if (nextUpcomingModelRunHasData()) {
                Next upcoming model run with data:
              } @else {
                {{ 'PRODUCT.EPS.MODELRUN.NEXTEXPECTED' | translate }}
              }
              <strong
                >{{
                  nextUpcomingModelRun()
                    | datex: 'short' : '' : language() : 'utc'
                }}z</strong
              >
            </span>
          }
        }
      }
    </div>
  </form>
  <mat-card class="chart-card">
    <div
      #chartShell
      class="chart-shell"
      [class.chart-shell--fullscreen]="isChartFullscreen()">
      <div class="chart-toolbar">
        @if (isComparisonMode()) {
          <div class="comparison-controls">
            <mat-form-field appearance="fill" class="comparison-select">
              <mat-label>{{
                'PRODUCT.EPS.MODELRUN.COMPARISONMODE' | translate
              }}</mat-label>
              <mat-select
                [value]="comparisonMode()"
                (selectionChange)="onComparisonModeChange($event.value)">
                <mat-option value="ensemble">Ensemble</mat-option>
                <mat-option value="difference">
                  {{ 'PRODUCT.EPS.MODELRUN.DIFFERENCETOREFERENCE' | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="comparison-select">
              <mat-label>{{
                'PRODUCT.EPS.MODELRUN.COMPAREBY' | translate
              }}</mat-label>
              <mat-select
                [value]="comparisonStatistic()"
                (selectionChange)="onComparisonStatisticChange($event.value)">
                @for (stat of comparisonStatistics; track stat) {
                  <mat-option [value]="stat">
                    {{ stat | uppercase }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            @if (comparisonMode() === 'difference') {
              <mat-form-field appearance="fill" class="comparison-select">
                <mat-label>{{
                  'PRODUCT.EPS.MODELRUN.REFERENCERUN' | translate
                }}</mat-label>
                <mat-select
                  [value]="referenceRun()"
                  (selectionChange)="onReferenceRunChange($event.value)">
                  @for (run of availableComparisonRuns(); track run) {
                    <mat-option [value]="run">
                      {{ formatRunLabel(run) }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </div>
        }

        <div class="chart-toolbar-actions">
          <button
            mat-icon-button
            type="button"
            (click)="toggleChartFullscreen()"
            [matTooltip]="
              isChartFullscreen()
                ? ('PRODUCT.EPS.MODELRUN.EXITFULLSCREEN' | translate)
                : ('PRODUCT.EPS.MODELRUN.FULLSCREEN' | translate)
            ">
            <fa-icon
              [icon]="[
                'far',
                isChartFullscreen() ? 'compress' : 'expand',
              ]"></fa-icon>
          </button>

          @if (isComparisonMode()) {
            <button
              mat-raised-button
              color="primary"
              (click)="showSingleChart()">
              {{ 'PRODUCT.EPS.MODELRUN.BACKTOSINGLERUN' | translate }}
            </button>
          } @else {
            <button
              mat-raised-button
              color="primary"
              (click)="showComparisonChart()">
              {{ 'PRODUCT.EPS.MODELRUN.COMPARERUNS' | translate }}
            </button>
          }
        </div>
      </div>

      <div class="chart-wrapper">
        @if (!showChartLoading()) {
          <highcharts-chart
            [Highcharts]="Highcharts"
            [constructorType]="chartConstructor"
            [options]="chartOptions()"
            [oneToOne]="true"
            [update]="updateFlag"
            style="
              width: 100%;
              height: 600px;
              display: block;
            "></highcharts-chart>
        }

        @if (showChartLoading()) {
          <app-loading-overlay
            text="Daten werden geladen..."
            [fullScreen]="false">
          </app-loading-overlay>
        } @else if (showChartEmptyState()) {
          <div class="empty-chart-overlay">
            <div class="empty-chart-content">
              <p>No data available for this model run yet.</p>
              <button
                mat-raised-button
                color="primary"
                (click)="selectLatestModelRun()">
                Select latest available Modelrun
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </mat-card>
</div>
